
  import createMeisterIcons from '../src/createMeisterIcons';

  const AlignRight = createMeisterIcons("align-right", [["path",{"fill":"currentColor","d":"M4.5 5.25a.75.75 0 0 0 0 1.5h15a.75.75 0 0 0 0-1.5zm6 4a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5zM3.75 14a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75m6.75 3.25a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5z","key":"6f54a862533d29ae718796eab51337ac35fb3c61","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default AlignRight
  